import React, {useEffect} from 'react';
import {Flex, Text} from "@chakra-ui/layout";
import {Grid, Image, Link} from "@chakra-ui/react";
import Doc from "../../../images/teacher/doc.svg";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {useSelector} from "react-redux";
import {getUploadedAssignments, getUploadedNotes} from "../../../action/teacherAction";

function UploadedNotes() {
  const dispatch = useStudentAuthDispatch();
  const {data, notes: {notes}} = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  const teacherToken = data.token.includes("Bearer") ? data.token.slice(17, (data.token.length - 2)) : data.token.slice(10, (data.token.length - 2));
  console.log(notes)

  useEffect(() => {
    dispatch(getUploadedNotes(teacherToken))
  }, []);

  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>Uploaded Notes</Text>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(250px, 1fr))"} justifyContent={"center"}>
        {notes.length < 1 ? (
          <Text textTransform={"capitalize"} textAlign={"center"}>No Uploaded Notes</Text>
        ) : notes.map((note: any, index) => (
          <Flex key={index} bgColor={"brand.white"} flexDirection={"column"} m={4} borderRadius={"20px"} p={6}>
            <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"lg"}>{note.course_name}</Text>
            <Text textTransform={"capitalize"} color={"gray.300"} fontSize={"sm"} mt={2} mb={4}>{note.teacher_username}</Text>
            <Link href={note.file_link} download>
              <Image
                title={"document"}
                src={Doc}
                alt={"document icon"}
                boxSize={"30px"}
                mr={1}
                d={"inline-block"}
              />
              {note.file_name}
            </Link>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
}

export default UploadedNotes;